var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "layout__controls" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card__content" }, [
            _c("div", { staticClass: "form-inline" }, [
              _c("div", { staticClass: "form-field select" }, [
                _c("div", { staticClass: "select-field" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.tipo_fecha,
                          expression: "form.tipo_fecha"
                        }
                      ],
                      attrs: { name: "tipo_fecha", id: "tipo_fecha" },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.form,
                              "tipo_fecha",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          _vm.changeTipoFecha
                        ]
                      }
                    },
                    [
                      _c("option", { attrs: { value: "A" } }, [
                        _vm._v("A la fecha")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "P" } }, [
                        _vm._v("Personalizado")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "tipo_fecha" } }, [
                    _vm._v("Tipo de consulta")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.tipo_fecha === "P",
                      expression: "form.tipo_fecha === 'P'"
                    }
                  ],
                  staticClass: "form-field"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "datepicker-field datepicker-field--stretch"
                    },
                    [
                      _c("VueCtkDateTimePicker", {
                        attrs: {
                          id: "desde",
                          locale: "es",
                          "no-label": "",
                          "only-date": "",
                          "auto-close": "",
                          "button-now-translation": "Ahora",
                          format: "YYYY-MM-DD",
                          formatted: "YYYY-MM-DD",
                          label: "Seleccione una fecha..."
                        },
                        model: {
                          value: _vm.form.desde,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "desde", $$v)
                          },
                          expression: "form.desde"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "label-nowrap",
                          attrs: { for: "desde" }
                        },
                        [_vm._v("Desde")]
                      ),
                      _vm._v(" "),
                      _vm.errores.desde
                        ? _c(
                            "span",
                            {
                              staticClass: "helper-text text-danger",
                              attrs: { slot: "helper" },
                              slot: "helper"
                            },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.errores.desde[0]))
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.tipo_fecha === "P",
                      expression: "form.tipo_fecha === 'P'"
                    }
                  ],
                  staticClass: "form-field"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "datepicker-field datepicker-field--stretch"
                    },
                    [
                      _c("VueCtkDateTimePicker", {
                        attrs: {
                          id: "hasta",
                          locale: "es",
                          "no-label": "",
                          "only-date": "",
                          "auto-close": "",
                          "button-now-translation": "Ahora",
                          format: "YYYY-MM-DD",
                          formatted: "YYYY-MM-DD",
                          label: "Seleccione una fecha..."
                        },
                        model: {
                          value: _vm.form.hasta,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "hasta", $$v)
                          },
                          expression: "form.hasta"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "label-nowrap",
                          attrs: { for: "hasta" }
                        },
                        [_vm._v("Hasta")]
                      ),
                      _vm._v(" "),
                      _vm.errores.hasta
                        ? _c(
                            "span",
                            {
                              staticClass: "helper-text text-danger",
                              attrs: { slot: "helper" },
                              slot: "helper"
                            },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.errores.hasta[0]))
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-info",
                  attrs: { type: "button" },
                  on: { click: _vm.consultar }
                },
                [
                  _c("i", { staticClass: "fa fa-search" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Consultar")])
                ]
              )
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid grid--fit" },
      [
        _c(
          "button-card",
          {
            attrs: {
              "btn-color": "btn-light",
              "fa-name": "fa-users",
              counter: _vm.usuariosSistema
            }
          },
          [_vm._v("USUARIOS EN EL SISTEMA")]
        ),
        _vm._v(" "),
        _c(
          "button-card",
          {
            attrs: {
              format: _vm.int,
              "btn-color": "btn-light",
              "fa-name": "fa-cloud",
              counter: _vm.documentosRobot
            }
          },
          [_vm._v("DOCUMENTOS EXTRAÍDOS POR MYBILLBOT")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid grid--fit" },
      [
        _c("info-box", {
          attrs: {
            quantity: _vm.cantidadesVenta,
            enableQuantity: "",
            totalVal: _vm.moneyFormat(_vm.montosVenta),
            title: "FV",
            descripcion: "Ventas",
            showButton: "",
            displayAnimation: _vm.animations.displayFV
          },
          on: { showCharts: _vm.mostrarFV }
        }),
        _vm._v(" "),
        _c("info-box", {
          attrs: {
            enableQuantity: "",
            quantity: _vm.cantidadesDv,
            colorClass: "info-box__abrv--danger",
            totalVal: _vm.moneyFormat(_vm.montosDv),
            title: "DV",
            descripcion: "Devoluciones en venta",
            showButton: "",
            displayAnimation: _vm.animations.displayDV
          },
          on: { showCharts: _vm.mostrarDV }
        }),
        _vm._v(" "),
        _c("info-box", {
          attrs: {
            enableQuantity: "",
            quantity: _vm.cantidadesRentaClientes,
            colorClass: "info-box__abrv--bus300",
            totalVal: _vm.moneyFormat(_vm.montosRentaClientes),
            title: "RC",
            descripcion: "Retenciones de renta de clientes",
            showButton: "",
            displayAnimation: _vm.animations.displayRC
          },
          on: { showCharts: _vm.mostrarRC }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mb-3" },
      [
        _c("transitionCharts", {
          attrs: {
            title: "Facturas de ventas",
            nameOption: "optionFV",
            displayAnimation: _vm.animations.displayFV,
            totalMontoElect: _vm.totalMontoElectFV,
            totalCantElect: _vm.totalCantElectFV,
            totalMontoManual: _vm.totalMontoManualFV,
            totalCantManual: _vm.totalCantManualFV,
            dataChartMontoManual: _vm.dataChartMontoManualFV,
            dataChartCantManual: _vm.dataChartCantManualFV,
            dataChartMontoElect: _vm.dataChartMontoElectFV,
            dataChartCantElect: _vm.dataChartCantElectFV
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mb-3" },
      [
        _c("transitionCharts", {
          attrs: {
            title: "Devoluciones de ventas",
            nameOption: "optionDV",
            displayAnimation: _vm.animations.displayDV,
            totalMontoElect: _vm.totalMontoElectDV,
            totalCantElect: _vm.totalCantElectDV,
            totalMontoManual: _vm.totalMontoManualDV,
            totalCantManual: _vm.totalCantManualDV,
            dataChartMontoManual: _vm.dataChartMontoManualDV,
            dataChartCantManual: _vm.dataChartCantManualDV,
            dataChartMontoElect: _vm.dataChartMontoElectDV,
            dataChartCantElect: _vm.dataChartCantElectDV
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mb-3" },
      [
        _c("transitionCharts", {
          attrs: {
            title: "Retenciones de renta de clientes",
            nameOption: "optionRC",
            displayAnimation: _vm.animations.displayRC,
            totalMontoElect: _vm.totalMontoElectRC,
            totalCantElect: _vm.totalCantElectRC,
            totalMontoManual: _vm.totalMontoManualRC,
            totalCantManual: _vm.totalCantManualRC,
            dataChartMontoManual: _vm.dataChartMontoManualRC,
            dataChartCantManual: _vm.dataChartCantManualRC,
            dataChartMontoElect: _vm.dataChartMontoElectRC,
            dataChartCantElect: _vm.dataChartCantElectRC
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid grid--fit" },
      [
        _c("info-box", {
          attrs: {
            enableQuantity: "",
            quantity: _vm.cantidadesIVAClientes,
            colorClass: "info-box__abrv--dark",
            totalVal: _vm.moneyFormat(_vm.montosIVAClientes),
            title: "IC",
            descripcion: "Retenciones de IVA de clientes",
            showButton: "",
            displayAnimation: _vm.animations.displayIC
          },
          on: { showCharts: _vm.mostrarIC }
        }),
        _vm._v(" "),
        _c("info-box", {
          attrs: {
            colorClass: "info-box__abrv--success",
            totalVal: _vm.moneyFormat(_vm.recaudadoAbonos),
            title: "AB",
            descripcion: "Recaudación de abonos"
          }
        }),
        _vm._v(" "),
        _c("info-box", {
          attrs: {
            colorClass: "info-box__abrv--warning",
            totalVal: _vm.moneyFormat(_vm.montosCompra),
            title: "CO",
            quantity: _vm.cantidadesCompra,
            enableQuantity: "",
            descripcion: "Compras"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mb-3" },
      [
        _c("transitionCharts", {
          attrs: {
            title: "Retenciones de IVA de clientes",
            nameOption: "optionIC",
            displayAnimation: _vm.animations.displayIC,
            totalMontoElect: _vm.totalMontoElectIC,
            totalCantElect: _vm.totalCantElectIC,
            totalMontoManual: _vm.totalMontoManualIC,
            totalCantManual: _vm.totalCantManualIC,
            dataChartMontoManual: _vm.dataChartMontoManualIC,
            dataChartCantManual: _vm.dataChartCantManualIC,
            dataChartMontoElect: _vm.dataChartMontoElectIC,
            dataChartCantElect: _vm.dataChartCantElectIC
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid grid--fit" },
      [
        _c("info-box", {
          attrs: {
            enableQuantity: "",
            quantity: _vm.cantidadesDc,
            colorClass: "info-box__abrv--secondary",
            totalVal: _vm.moneyFormat(_vm.montosDc),
            title: "DC",
            descripcion: "Devoluciones en compras"
          }
        }),
        _vm._v(" "),
        _c("info-box", {
          attrs: {
            enableQuantity: "",
            quantity: _vm.cantidadesRentaProveedores,
            colorClass: "info-box__abrv--bus400",
            totalVal: _vm.moneyFormat(_vm.montosRentaProveedores),
            title: "RP",
            descripcion: "Retenciones de renta a proveedores"
          }
        }),
        _vm._v(" "),
        _c("info-box", {
          attrs: {
            enableQuantity: "",
            quantity: _vm.cantidadesIVAProveedores,
            colorClass: "info-box__abrv--primary",
            totalVal: _vm.moneyFormat(_vm.montosIVAProveedores),
            title: "RP",
            descripcion: "Retenciones de IVA a proveedores"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid grid--fit" },
      [
        _c("info-box", {
          attrs: {
            colorClass: "info-box__abrv--warning",
            totalVal: _vm.moneyFormat(_vm.cuentasPorCobrar),
            title: "CC",
            descripcion: "Cuentas por cobrar"
          }
        }),
        _vm._v(" "),
        _c("info-box", {
          attrs: {
            colorClass: "info-box__abrv--success",
            totalVal: _vm.moneyFormat(_vm.liquidez),
            title: "LQ",
            descripcion: "Liquidez"
          }
        }),
        _vm._v(" "),
        _c("info-box", {
          attrs: {
            colorClass: "info-box__abrv--info",
            totalVal: _vm.moneyFormat(_vm.comisiones),
            title: "CV",
            descripcion: "Comisiones de vendedores"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-3" }, [
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "card" }, [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card__content" },
            [
              _c("pie-chart", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.comisionesPorVendedores.length > 0,
                    expression: "comisionesPorVendedores.length > 0"
                  }
                ],
                attrs: { data: _vm.comisionesPorVendedores }
              }),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.comisionesPorVendedores.length === 0,
                      expression: "comisionesPorVendedores.length === 0"
                    }
                  ]
                },
                [_c("strong", [_vm._v("No se ha encontrado información.")])]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "card" }, [
          _vm._m(2),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card__content" },
            [
              _c("pie-chart", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.recaudacionAbonosCxc.length > 0,
                    expression: "recaudacionAbonosCxc.length > 0"
                  }
                ],
                attrs: { data: _vm.recaudacionAbonosCxc }
              }),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.recaudacionAbonosCxc.length === 0,
                      expression: "recaudacionAbonosCxc.length === 0"
                    }
                  ]
                },
                [_c("strong", [_vm._v("No se ha encontrado información.")])]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "card" }, [
          _vm._m(3),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card__content" },
            [
              _c("column-chart", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.ordenesTrabajo.length > 0,
                    expression: "ordenesTrabajo.length > 0"
                  }
                ],
                attrs: { data: _vm.ordenesTrabajo }
              }),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.ordenesTrabajo.length === 0,
                      expression: "ordenesTrabajo.length === 0"
                    }
                  ]
                },
                [_c("strong", [_vm._v("No se ha encontrado información.")])]
              )
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-3" }, [
      _c("div", { staticClass: "col-xs-12" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card__title" }, [
            _c("h5", [_vm._v("Distribución entre ventas y compras (anual)")]),
            _vm._v(" "),
            _c("div", { staticClass: "card__controls" }, [
              _c("div", { staticClass: "form-field select select--stretch" }, [
                _c(
                  "div",
                  { staticClass: "select-field select-field--stretch" },
                  [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.periodo,
                            expression: "form.periodo"
                          }
                        ],
                        attrs: { name: "periodo", id: "periodo" },
                        on: {
                          input: _vm.consultar,
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.form,
                              "periodo",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      _vm._l(_vm.periodos, function(periodo) {
                        return _c(
                          "option",
                          { key: periodo, domProps: { value: periodo } },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(periodo) +
                                "\n                  "
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "periodo" } }, [
                      _vm._v("Período")
                    ])
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card__content" },
            [_c("line-chart", { attrs: { data: _vm.arrayMeses } })],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Dashboard")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Comisiones por vendedores")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Recaudación de abonos")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Órdenes de trabajo")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48d34360", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48d34360","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/KDashboard.vue
// module id = 622
// module chunks = 0